<template>
  <div class="app" v-bind:class="{ 'dark-mode': currentTheme, 'dev-env': !currentEnv }" v-if="initialized">
    <template>
      <AppHeader fixed>
        <span @click="backToDashboard" v-if="$can('dashboard access')"><i class="fa fa-desktop"></i></span>
        <b-link class="navbar-brand" to="/admin/dashboard">
          <Projects @project_changed="reRender()" />
        </b-link>

        <b-navbar-nav class="ml-auto">
          <b-nav-item class="d-md-down-none notification-bell" to="/admin/scout/events">
            <i class="icon-bell"></i>
            <template v-if="newEvents">
              <b-badge pill variant="danger" v-if="newEvents < 10"> {{ newEvents }}</b-badge>
              <b-badge pill variant="danger" v-else> 9+ </b-badge>
            </template>
          </b-nav-item>
          <DefaultHeaderDropdownAccnt />
        </b-navbar-nav>
        <AsideToggler class="d-none d-lg-block" />
        <AsideToggler class="d-lg-none" mobile />
      </AppHeader>
      <div class="app-body">
        <notifications group="system" position="top right" :ignoreDuplicates="true" />
        <notifications group="dataChanged" position="bottom right">
          <template slot="body">
            <div class="vue-notification" @click="$router.go()">
              {{ $t('dataHasChanged') }}
            </div>
          </template>
        </notifications>
        <b-modal title="We experienced unexpected error!" id="report-error-modal" ok-title="Send" ok-variant="success"
          @ok="sendErrorReport">
          <b-textarea style="min-height: 100px" :placeholder="this.$t('explainUs')"
            v-model="serverError.comment"></b-textarea>
        </b-modal>
        <main class="main">

          <b-nav pills class="mb-4 home-nav d-none d-md-flex" v-if="$route.name != 'Home'">
            <b-nav-item @click="$router.go(-1)"> <b-icon icon="chevron-left" /> </b-nav-item>
            <b-nav-item @click="$router.push('/')"> <b-icon icon="house" /> </b-nav-item>
            <b-nav-item-dropdown v-if="bookmarks.length > 0">
              <template #button-content><b-icon icon="star" /></template>

              <b-dropdown-item v-for="bookmark in bookmarks" :key="bookmark.uuid" @click="openBookmark(bookmark)">
                {{ $translateLabel(bookmark.label, bookmark.name) }}
              </b-dropdown-item>
            </b-nav-item-dropdown>

            <b-nav-item-dropdown v-if="apps.length > 0" :text="$t('apps')">

              <b-dropdown-item v-for="app in apps" :key="app.uuid" @click="openApp(app)">
                {{ $translateLabel(app.label, app.name) }}
              </b-dropdown-item>
            </b-nav-item-dropdown>

            <b-nav-item-dropdown v-if="components.length > 0" :text="$t('components')">

              <b-dropdown-item v-for="component in components" :key="component.uuid" @click="openComponent(component)">
                {{ $translateLabel(component.label, component.name) }}
              </b-dropdown-item>
            </b-nav-item-dropdown>

            <RenderEvent event="home" tag="b-nav-item-dropdown" :text="$t('integrations.title')" key="integrations">
              <template v-slot:default="{ elements }">
                <b-dropdown-item v-for="(element, idx) in elements" @click="openIntegration(element.context)"
                  :key="idx">
                  {{ $translateLabel(element.context.label, element.context.id) }}
                </b-dropdown-item>
              </template>

            </RenderEvent>
          </b-nav>

          <b-nav pills class="mb-4 home-nav d-flex d-md-none" v-if="$route.name != 'Home'">
            <b-nav-item @click="$router.go(-1)"> <b-icon icon="chevron-left" /> </b-nav-item>
            <b-nav-item @click="$router.push('/')"> <b-icon icon="house" /> </b-nav-item>
          </b-nav>

          <div class="container-fluid" style="margin-top:20px">
            <b-alert show v-if="doesntBelongToProject" variant="warning"> {{ $t('noRolesOnCurrentProject') }} </b-alert>
            <b-alert show v-else-if="noWorkspace" style="text-align: center">{{ $t("notBelongToWorkspace") }}
              {{ this.$store.getters.getCurrentProject.name }}. {{ $t("contactAdministrator") }} <b-button @click="logout"
                variant="primary"> {{ $t("logout") }} </b-button> </b-alert>
            <template v-else>
              <router-view></router-view>
            </template>
          </div>
        </main>
        <AppAside fixed>
          <!--aside-->
          <Workspaces @workspaceChange="reRender()" />
        </AppAside>
      </div>
      <TheFooter>
        <!--footer-->

        <div class="mr-4">
          <c-switch color="protokol" variant="pill" :label="true" dataOn="live" dataOff="dev" v-model="currentEnv"
            v-if="this.$can('dev env_access') || this.$isAdmin()" />
        </div>

        <div class="clr-protokol-royal-purple">
          <a class="clr-protokol-royal-purple active" href="https://protokol.io">{{ $t('protokol') }}</a>
          <router-link to="/admin/platform/updates">
            <span class="ml-1 clr-protokol-royal-purple active">v{{ version }}</span>
          </router-link>
          <span class="ml-1">&copy; {{ getYear }}</span>
        </div>
        <!--End of Tawk.to Script-->

      </TheFooter>
    </template>

    <protokol-tutorial />

    <Onboarding v-if="$isAdmin()" />
  </div>
</template>

<style lang="scss">
.switch-protokol .switch-input:checked+.switch-slider {
  background-color: #6C63FF;
  border: 1px solid #6C63FF;
}

.workspaceMarker {
  background-color: #000;
  padding: 10px;
}

.workspaceMarkerActive {
  height: 50px;
}

.notification-bell {
  margin-right: 10px;
}

.dark-mode {
  .navbar-nav .nav-link:hover {
    color: #ccc;
  }

  .navbar-nav .nav-link.active {
    color: #ccc;
  }
}

.bookmark-item {
  // border-left: 1px solid rgba(255,255,255,0.5);
}

a.dropdown-item i.fa.fa-star-o {
  margin-left: 10px;
}

a.icon-holder {
  right: 10px;
  top: 5px;
  position: absolute;
  font-size: 20px;
  padding-left: 10px;
  padding-right: 10px;
  z-index: 10;
}

.sidebar-divider {
  display: block !important;
  background-color: #2c3135;
}

.fa-desktop {
  &:hover {
    color: #6C63FF;
  }

  cursor: pointer;
  position: relative;
  margin-left: 15px;
}
</style>

<style scoped>
.main,
.app-footer {
  margin-left: 0px !important;
}

.home-nav {
  border-bottom: 1px solid #373d41;
}
</style>

<script>
import nav from '@/_nav'
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Breadcrumb, Aside as AppAside, AsideToggler, Footer as TheFooter } from '@/components/ui/vue/src'
import SidebarNavItem from '@/components/ui/vue/src'
import Projects from './Projects'
import Workspaces from './Workspaces'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'
import ProjectCreate from '../views/projects/Create'
import Changelog from '../../changelog.json'
import { Switch as cSwitch } from '@coreui/vue'
import Input from '@/components/form/Input'
import _ from 'lodash'
import { Howl } from 'howler';
import RenderEvent from '../components/integrations/RenderEvent'
import Onboarding from '@/views/dashboard/Onboarding'
import claimsMixin from './claimsMixin'

export default {
  name: 'HomeContainer',
  mixins: [claimsMixin],
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Projects,
    Workspaces,
    Breadcrumb,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    ProjectCreate,
    cSwitch,
    InputField: Input,
    RenderEvent,
    SidebarNavItem,
    Onboarding
  },
  data() {
    return {
      ready: false,
      componentsReady: false,
      doesntBelongToProject: false,
      noWorkspace: false,
      projectInfo: null,
      appUrl: null,
      createWorkspace: {
        modal: false,
        name: ''
      },
      errors: [],
      menu: [],
      initialized: false,
      subscriptionAlert: null
    }
  },
  computed: {
    apps() {
      return this.$store.getters.getApps
    },

    bookmarks: {
      get() {
        let bookmarks = _.get(this.$store.getters.projectUserConfig("bookmarks"), "data", {})

        return Object.values(bookmarks).map(c => {
          return this.$store.getters.componentsMenu.find(f => {
            return c.name == f.name
          })
        }).filter(b => {
          if (!b) return false

          if (!b.is_active) {
            return false
          }

          if (b.is_public && this.$store.getters.isLiveEnv) {
            return true
          }

          return !this.$store.getters.isLiveEnv
        })
      },

      set(val) {
        let bookmarks = {}
        Object.values(val).forEach(v => {
          bookmarks[v.name] = v
        })

        this.$store.dispatch('updateProjectUserConfig', { path: "bookmarks", data: bookmarks })
      }
    },

    components() {
      let componentsMenu = this.$store.getters.componentsMenu.filter(c => {
        return c.is_public
      })

      let m = this.menu
      m = componentsMenu;

      m.sort((a, b) => {
        return a.sort - b.sort
      })

      return m
    },

    getYear() {
      return new Date().getFullYear()
    },

    version() {
      return Changelog[0].version
    },
    settingsPath() {
      return this.$route.meta.settingsPath
    },

    name() {
      return this.$route.name
    },
    list() {
      return this.$route.matched.filter((route) => {
        return route.name || route.meta.label
      })
    },

    workspaces() {
      return this.$store.getters.getCurrentProject.workspaces.filter(w => {
        return w.uuid != this.$store.getters.getCurrentWorkspace.uuid
      })
    },

    workspace() {
      return this.$store.getters.getCurrentWorkspace
    },

    sidebarNav() {
      let i = _.cloneDeep(nav.items).map(i => {
        i.name = this.$t(i.name.toLowerCase())
        if (i.children) {
          i.children = i.children.map(c => {
            c.name = this.$t(c.name.toLowerCase())
            return c
          })
        }

        return i
      })

      if (this.$can("manage base_components")) {
        i.push({
          name: this.$t('add'),
          url: '/admin/components/create',
          icon: 'icon-plus'
        })
      }

      return i
    },

    projects() {
      return this.$store.getters.projects
    },

    serverError() {
      return {
        comment: '',
        request_uuid: this.$store.getters.errorRequestID
      }
    },

    accountExpiresAt() {
      let user = this.$store.getters.getUser;

      if (user.expires_at === null || user.expires_at == "") {
        return null
      }

      return user.expires_at;
    },

    subscriptions() {
      return this.$store.getters.getSubscriptions
    },

    currentEnv: {
      get() {
        return this.$store.getters.getCurrentEnv == 'live'
      },

      set(val) {
        this.$store.dispatch("setCurrentEnv", val ? "live" : "dev").then(() => {
          this.reRender()

          if (this.$store.getters.getCurrentEnv == 'dev')
            this.$store.dispatch("initTutorial", "dev")
        })
      }
    },

    currentTheme: {
      get() {
        return this.$store.getters.getCurrentTheme == 'dark'
      },

      set(val) {
        this.$store.dispatch("setCurrentTheme", val ? "dark" : "light")
      }
    },

    currentWorkspace: {
      get() {
        return this.$store.getters.getCurrentWorkspace
      },

      set(val) {
        this.$store.dispatch("setWorkspace", val).then(() => {
          this.reRender()
        })
      }
    },

    currentWorkspaceName() {
      if (this.currentWorkspace !== undefined)
        return _.truncate(this.currentWorkspace.name, { length: 10 })

      return null
    },

    currentProjectName() {
      if (this.$store.getters.getCurrentProject) {
        return _.truncate(this.$store.getters.getCurrentProject.name, { length: 15 })
      }
    },

    newEvents() {
      return this.$store.getters.newEventsCount
    },

    userClaims() {
      return this.$store.getters.getClaims
    }
  },

  methods: {
    reRender() {
      this.$store.dispatch('refreshState')
      this.$store.commit("RELOAD_CONTAINER")
    },

    changeWorkspace(workspace) {
      this.currentWorkspace = workspace
    },

    logout() {
      this.$http.post("/v1/user/logout").then(resp => {
        this.$router.go()
      })
    },

    displayDataChanged(data) {
      let currentComponentUUID = this.$store.getters.currentComponent.uuid
      let currentUser = this.$store.getters.getUser

      if ((data.data.component.uuid == currentComponentUUID)
        && data.user.uuid !== currentUser.uuid
      ) {

        this.$bvToast.toast("Data Changed", {
          variant: 'primary',
          autoHideDelay: 10000
        })
        
      }
    },

    sendErrorReport() {
      this.$http.post("/v1/system/report", this.serverError).then(resp => {
        this.$bvModal.msgBoxOk(this.$t("thanksFeedback"))
      })
    },

    projectCreated() {
      this.$router.go('/admin/dashboard');
    },

    fieldError(error) {
      let found = this.errors.find((i, e) => {
        return i.field == error.field
      })

      if (found === undefined) {
        this.errors.push(error)
      } else {
        this.errors.map(e => {
          if (found.field == e.field)
            e.error = error.error
        })
      }
    },

    checkForErrors() {
      return this.errors.find((i, e) => {
        return i.error
      })
    },

    playNotification() {
      let notificationSettings = this.$store.getters.userConfig("notification_settings");
      if (!notificationSettings) return

      if (notificationSettings.data.play_sound) {
        var sound = new Howl({
          src: ['../sound/notification.wav']
        });

        sound.play();
      }
    },

    openComponent(component) {
      let ref = component.name
      if (component.scope) {
        ref = `${component.scope}/${ref}`
      }

      this.$router.push(`/home/component/${ref}`)
    },

    openApp(app) {
      this.$router.push(`/app/${app.name}`)
    },

    isBookmarkActive(name) {
      return !!this.bookmarks.find(b => {
        return b.name == name
      });
    },

    bookmarkApp(e, app) {
      e.stopImmediatePropagation();
      let data = this.bookmarks || {};
      let bookmark = data.find(d => {
        return d.name == app.name
      })

      if (bookmark) {
        data = data.filter(d => {
          return d.name != bookmark.name
        })
      } else {
        data.push({
          name: app.name,
          url: app.url
        })
      }

      this.bookmarks = data
    },

    openBookmark(bookmark) {
      this.$router.push(bookmark.url)
    },

    openIntegration(int) {
      this.$router.push(`/home/integrations/page/${int.id}`)
    },

    bookmarkLabelTranslate(bookmark) {
      try {
        let component = this.$store.getters.components.find(c => {
          return c.name == bookmark.name
        })

        return this.$translateLabel(component.label) || bookmark.name
      } catch {
        // do nothing
        return bookmark.name
      }
    },

    backToDashboard() {
      this.$router.push("/admin/dashboard")
    }
  },

  async created() {
    this.$store.dispatch("fetchIntegrations");
    this.$store.dispatch("fetchTrials")

    try {
      await this.$setupComponents()

      this.componentsReady = true
      this.noWorkspace = false
    } catch (err) {
      if (err.response !== undefined) {
        if (err.response.status == 400) {
          this.doesntBelongToProject = true
          return
        }

        if (err.response.status >= 500) {
          this.$bvToast.toast(this.$t('unexpectedError'), {
            variant: 'danger'
          })
          return
        }

        if (err.response.status == 403) {
          this.componentsReady = true
        }
      }

      if (err == "noWorkspace" && this.$store.getters.currentWorkspace == null) {
        this.noWorkspace = true
        return
      }

      this.$debugLog(err)
      this.$bvToast.toast(this.$t('unexpectedError'), {
        variant: 'danger'
      })
    } finally {
      this.initialized = true
    }
  },

  async mounted() {
    await this.$store.dispatch("fetchPermissions")

    if (!this.$can('dev env_access')) {
      this.$store.dispatch("setCurrentEnv", "live")
    }

    this.$store.dispatch("fetchSubscriptions").then(data => {
      let expired = data.filter(d => {
        return d.is_expired
      })

      let cancelled = data.filter(d => {
        return d.is_canceled
      })

      if (cancelled.length > 0) {
        let msg = this.$t("cancelledSubscriptions", {
          services: cancelled.map(c => {
            return c.license_product.name
          }).join(",")
        })

        this.$bvToast.toast(msg, {
          variant: 'warning'
        })
      }

      if (expired.length > 0) {
        let msg = this.$t("subscriptionExpired", {
          services: expired.map(c => {
            return c.license_product.name
          }).join(",")
        })

        this.$bvToast.toast(msg, {
          variant: 'danger'
        })
      }

    }).catch(err => {
      this.$store.commit("SET_SUBSCRIPTIONS", []);
    })

    localStorage.setItem("run_mode", "platform");
    localStorage.setItem("current_theme", "dark");

    this.$store.dispatch("fetchNewEventsCount");

    this.$store.commit("SET_CURRENT_CONTEXT", "home")

    this.$store.dispatch("initTutorial", "introduction")

    if (this.$store.getters.getCurrentEnv == 'dev')
      this.$store.dispatch("initTutorial", "dev")
  }
}
</script>
